<!--- Event by Time -->
<!--- ToDo: need to refactor this template -->
<div class="race-list">
    @if (events.length) {
        <div class="container-inner-content" data-crlat="accordionsList">
            <a
                *ngFor="let eventEntity of orderedEvents"
                class="odds-card"
                [attr.data-eventid]="eventEntity.id"
                [routerLink]="getLink(sportName, eventEntity)"
                data-crlat="raceList.eventEntity">
                <div class="odds-content">
                    <div class="odds-content-wrapper">
                        <svg class="odds-icon" data-crlat="oddsIcon">
                            <use [attr.xlink:href]="getIconName()"></use>
                        </svg>
                        <div
                            class="odds-info-wrapper odds-names"
                            [ngClass]="{ 'odds-normal': !isLpAvailable(eventEntity), 'race-resulted': eventEntity.isResulted }"
                            data-crlat="raceList.raceTime">
                            <span class="race-time">{{ getRaceTime(eventEntity) }}</span>
                            @if (eventEntity.isResulted) {
                                <svg class="race-icon">
                                    <use xlink:href="#result-post"></use>
                                </svg>
                            }
                        </div>
                        <!--<div oc-lazy-load="['promotions']">-->
                        <promotion-icon [type]="'event'" [display]="eventEntity.drilldownTagNames" data-crlat="promotionIcons"> </promotion-icon>
                        <!-- </div>-->
                    </div>
                </div>
                <div class="odds-content" data-crlat="oddsContent">
                    @if (eventEntity.liveStreamAvailable) {
                        <div class="odds-left">
                            <svg class="odds-icon-stream small-icon">
                                <use xlink:href="#stream"></use>
                            </svg>
                            <span class="odds-small" [i18n]="'sb.watchLive'"></span>
                        </div>
                    }
                    <div class="odds-right">
                        <div class="odds-small race-card-link" data-crlat="linkRaceCard">Go To Race Card</div>
                    </div>
                </div>
            </a>
        </div>
    }
    @if (events.length && events.length > limited) {
        <button class="show-all-button" data-crlat="raceList.buttonShowAll" (click)="showMore()" [i18n]="'sb.showMore'"></button>
    }
    <!-- Show only when no events -->
    @if (!events.length) {
        <no-events></no-events>
    }
</div>
